export default __webpack_public_path__ + "static/media/composicao_background.6197c378.png";